import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { CookieStorageService } from '../services/cookie-storage.service';
import { AUTHORIZATION_TYPE, DEMO, ERROR_TYPE_VIEW } from "../tokens/context.tokens";
import { HmacService, RequestMethod } from "../services/hmac.service";

@Injectable({
  providedIn: 'root',
})
export class CommonInterceptor implements HttpInterceptor {
  constructor(
    // private notifications: PopupNotificationsService,
    private router: Router,
    private cookieService: CookieStorageService,
    private hmac: HmacService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    switch (req.context.get(AUTHORIZATION_TYPE)) {
      case 'hmac': return this.addHmacTokenToRequest(req, next);
      default: return next.handle(req)
        .pipe(catchError(err => this.handleError(err, req, next)))
    }
  }

  addHmacTokenToRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next
      .handle(req.clone({ setHeaders: { Authorization: this.hmac.generateToken(req.url, req.method as RequestMethod, req.body) } }))
      .pipe(catchError(err => this.handleError(err, req, next)));
  }

  private handleError(
    err: any,
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.method === 'GET') {
      if (req.context.get(ERROR_TYPE_VIEW) === 'page') {
        if (this.router.url.includes('lk')) {
          this.cookieService.remove('lastLkPagePath');
          this.cookieService.remove('lastLkPageQuery');
        }

        switch (err.status) {
          case 400:
            this.router.navigateByUrl('/404', {
              skipLocationChange: true,
              state: { message: err.error.error },
            });
            break;
          case 404:
            this.router.navigateByUrl('/404', { skipLocationChange: true });
            break;
          case 403:
            this.router.navigateByUrl('/403', { skipLocationChange: true });
            break;
          case 423:
            this.router.navigate(['/423'], {
              skipLocationChange: true,
              state: { message: err.error.error },
            });
            break;
          default:
            this.router.navigateByUrl('/http-error', {
              skipLocationChange: true,
            });
            break;
        }
      } else if (req.context.get(ERROR_TYPE_VIEW) === 'popup') {
        if (err.status !== 0) {
          // this.notifications.generateNotification(this.errors[404], 'error');
        }
      }
    } else {
      if (req.context.get(ERROR_TYPE_VIEW) === 'popup') {
        this.generateNotificationByErrorStatus(
          err.status,
          err.error ? err.error.error : this.errors[err.status]
        );
      }
    }
    return throwError(err);
  }

  private generateNotificationByErrorStatus(status: number, message?: string) {
    if (status === 0) return;

    const errorMessage =
      this.errors[status.toString()] || message || 'Неизвестная ошибка';
    // this.notifications.generateNotification(errorMessage, 'error');
  }

  private errors: any = {
    '401': 'Вы не авторизованы',
    '403': 'У вас нет доступа',
    '404': 'Информация не найдена',
    '0': 'Что-то пошло не так. \n Проверьте соединение',
    '500':
      'Сервер недоступен в данный момент. \n Попробуйте повторить запрос позже.',
  };
}
